module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-alert', {
    attrs: {
      "closable": false,
      "title": "裁判长申报联系人： 寇磊 18551717417",
      "type": "warning"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-divider', [_vm._v("赛事信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛事名称",
      "prop": "saiqu_name",
      "rules": [{
        required: true,
        message: '请输入赛事名称',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入赛事名称"
    },
    model: {
      value: (_vm.formData.saiqu_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "saiqu_name", $$v)
      },
      expression: "formData.saiqu_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "竞赛规程文件/补充通知",
      "prop": "files",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur'
      } ]
    }
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "上传文件",
      "fileList": _vm.formData.files,
      "limit": 2,
      "accept": ".doc,.pdf,.docx",
      "name": 'files'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("【含收费情况、比赛时间和地点】（上传word或pdf）")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拟担任裁判情况",
      "prop": "cptype",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "裁判长"
    },
    model: {
      value: (_vm.formData.cptype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cptype", $$v)
      },
      expression: "formData.cptype"
    }
  }, [_vm._v("裁判长")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "高级裁判组组长"
    },
    model: {
      value: (_vm.formData.cptype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cptype", $$v)
      },
      expression: "formData.cptype"
    }
  }, [_vm._v("高级裁判组组长")]), _vm._v(" "), _c('br'), _vm._v("只有担任裁判长或高级裁判组组长才需要报备，一般打分裁判员无需报备。\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "举办时间",
      "prop": "date_range",
      "rules": [{
        required: true,
        message: '请输入举办时间',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.formData.date_range),
      callback: function($$v) {
        _vm.$set(_vm.formData, "date_range", $$v)
      },
      expression: "formData.date_range"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "举办地点",
      "prop": "area",
      "rules": [{
        required: true,
        message: '请选择举办地点',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主办单位",
      "prop": "zb",
      "rules": [{
        required: true,
        message: '请填写主办单位',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请填写主办单位"
    },
    model: {
      value: (_vm.formData.zb),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zb", $$v)
      },
      expression: "formData.zb"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "承办单位",
      "prop": "cb",
      "rules": [{
        required: true,
        message: '请填写承办单位',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请填写承办单位"
    },
    model: {
      value: (_vm.formData.cb),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cb", $$v)
      },
      expression: "formData.cb"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "协办单位",
      "prop": "xb"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请填写协办单位"
    },
    model: {
      value: (_vm.formData.xb),
      callback: function($$v) {
        _vm.$set(_vm.formData, "xb", $$v)
      },
      expression: "formData.xb"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "参赛费收费标准",
      "prop": "sai_price",
      "rules": [{
        required: true,
        message: '请填写参赛费收费标准',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请填写参赛费收费标准"
    },
    model: {
      value: (_vm.formData.sai_price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sai_price", $$v)
      },
      expression: "formData.sai_price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "食宿费收费标准",
      "prop": "shisu_price",
      "rules": [{
        required: true,
        message: '请填写食宿费收费标准',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请填写食宿费收费标准"
    },
    model: {
      value: (_vm.formData.shisu_price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shisu_price", $$v)
      },
      expression: "formData.shisu_price"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公安机关报备",
      "prop": "police_report",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.formData.police_report),
      callback: function($$v) {
        _vm.$set(_vm.formData, "police_report", $$v)
      },
      expression: "formData.police_report"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.formData.police_report),
      callback: function($$v) {
        _vm.$set(_vm.formData, "police_report", $$v)
      },
      expression: "formData.police_report"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('div', [_vm._v("赛事是否已与县级及以上公安机关报备。"), _c('br'), _vm._v("必须向公安机关报备才能申请通过。")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购买责任险",
      "prop": "is_baoxian",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.formData.is_baoxian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_baoxian", $$v)
      },
      expression: "formData.is_baoxian"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.formData.is_baoxian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_baoxian", $$v)
      },
      expression: "formData.is_baoxian"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('div', [_vm._v("是否已购买赛事公众责任险。"), _c('br'), _vm._v("必须购买赛事公众责任险才能申请通过。")])], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛事简介",
      "prop": "content",
      "rules": [{
        required: true,
        message: '请输入赛事简介',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("总裁判长个人信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号",
      "prop": "num",
      "rules": [{
        required: true,
        message: '请输入证件号',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px !important"
    },
    attrs: {
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.formData.cardtype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cardtype", $$v)
      },
      expression: "formData.cardtype"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "身份证",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "护照",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    key: 3,
    attrs: {
      "label": "其他",
      "value": 3
    }
  })], 1), _vm._v(" "), (_vm.formData.cardtype == 1) ? _c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    on: {
      "blur": _vm.getCaipanGrade
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.num"
    }
  }) : _c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号"
    },
    on: {
      "blur": _vm.getCaipanGrade
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申报人微信",
      "prop": "weixin",
      "rules": [{
        required: true,
        message: '请输入申报人微信',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入申报人微信"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申报人邮箱",
      "prop": "email",
      "rules": [{
          required: true,
          message: '请输入申报人邮箱',
          trigger: 'blur',
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }
      ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入申报人邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone",
      "rules": [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        {
          validator: _vm.validator.phone,
          message: '请输入正确的手机号'
        } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "phonecode",
      "rules": [{
        required: true,
        message: '请输入验证码',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.clockSecond > 0
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
    '(' + _vm.clockSecond + 's)' : '获取验证码'))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "裁判证编号",
      "prop": "cert_no",
      "rules": [{
        required: true,
        message: '请输入裁判证编号',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入裁判证编号"
    },
    model: {
      value: (_vm.formData.cert_no),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cert_no", $$v)
      },
      expression: "formData.cert_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "裁判等级",
      "prop": "cert_grade",
      "rules": [{
        required: true,
        message: '请选择裁判等级',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择裁判等级"
    },
    model: {
      value: (_vm.formData.cert_grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cert_grade", $$v)
      },
      expression: "formData.cert_grade"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "国际级",
      "value": "国际级"
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "国家级",
      "value": "国家级"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工作单位",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '请输入工作单位',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入工作单位"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "承诺",
      "prop": "comfirm",
      "rules": [{
        required: true,
        message: '请勾选承诺',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.formData.comfirm),
      callback: function($$v) {
        _vm.$set(_vm.formData, "comfirm", $$v)
      },
      expression: "formData.comfirm"
    }
  }, [_vm._v("我承诺赛事期间向参赛代表队投放满意度调查报告，并于5日内回传成绩册、赛事总结报告。")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76192058","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cpz/CpzApplyFormStep1.vue
// module id = 1542
// module chunks = 0